import Cookies from "js-cookie";

// state
export const state = {
  guestInfo: Cookies.get("guest") ? JSON.parse(Cookies.get("guest")) : "",
  guestAddress: Cookies.get("guest-address")
    ? JSON.parse(Cookies.get("guest-address"))
    : "",
  guestSessionId: Cookies.get("guest-session-id")
    ? Cookies.get("guest-session-id").replace(/['"]+/g, "")
    : "",
};

// mutations
export const mutations = {
  SET_INFO: (state, info) => {
    Cookies.set("guest", JSON.stringify(info), { expires: 365 });
    state.guestInfo = info;
  },
  REMOVE_INFO: () => {
    Cookies.remove("guest");
    state.guestInfo = "";
  },
  SET_ADDRESS: (state, address) => {
    Cookies.set("guest-address", JSON.stringify(address), { expires: 365 });
    state.guestAddress = address;
  },
  REMOVE_ADDRESS: () => {
    Cookies.remove("guest-address");
    state.guestAddress = "";
  },
  SET_SESSION_ID: (state, sessionId) => {
    Cookies.set("guest-session-id", JSON.stringify(sessionId), {
      expires: 365,
    });
    state.guestSessionId = sessionId;
  },
  REMOVE_SESSION_ID: () => {
    Cookies.remove("guest-session-id");
    state.guestSessionId = "";
  },
};

// actions
export const actions = {
  setInfo({ commit }, payload) {
    commit("SET_INFO", payload);
  },
  removeInfo({ commit }) {
    commit("REMOVE_INFO");
  },
  setAddress({ commit }, payload) {
    commit("SET_ADDRESS", payload);
  },
  removeAddress({ commit }) {
    commit("REMOVE_ADDRESS");
  },
  setSessionId({ commit }, payload) {
    commit("SET_SESSION_ID", payload);
  },
  removeSessionId({ commit }) {
    commit("REMOVE_SESSION_ID");
  },
  resetInfoAddress({ commit }) {
    commit("REMOVE_INFO");
    commit("REMOVE_ADDRESS");
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
